import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddHomework from "../../../containers/superadmin/homework/models/add-homework";
import DeleteHomework from "../../../containers/superadmin/homework/models/delete-homework";
import SearchBar from "../../../containers/superadmin/homework/searchbar";
import HomeworkTable from "../../../containers/superadmin/homework/table";

import AddHomeworkExamData from "../../../containers/admin/homework/models/add-exam-data";
import { getAllHomeworksRequest } from "../../../modules/superadmin-modules/homework/Actions";

const SuperadminHomeworks = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [courseId, setCourseId] = useState(null);

  const [selectedData, setSelectedData] = useState({});

  // useEffect(() => {
  //   dispatch(getAllHomeworksRequest());
  //   dispatch(getStudentHomeworkQuizRequest());
  // }, []);

  useEffect(() => {
    if (courseId) dispatch(getAllHomeworksRequest(courseId));
  }, [courseId]);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setCourseId={setCourseId} />
      <AddHomework
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />

      <AddHomeworkExamData
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />

      <HomeworkTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <DeleteHomework data={selectedData} />
    </Layout>
  );
};

export default SuperadminHomeworks;
